module.exports = __webpack_public_path__ + "img/my-location.a3e6bbd4.svg";